import BreadCrumb from "../../../components/BreadCrumb";
import Button from "../../../components/Button";
import CardCount from "../../../components/CardCount";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { Grid } from "@mui/material";
import { Group as StudentIcon, Class as ClassIcon } from "@mui/icons-material";
import NoRecentUsers from "../../../assets/images/nofeatureicons/norecentuser.svg";
import Table from "../../../components/Table/Table";
import useStyles from "../styles";
import { TableSearch } from "../../../components/Table/TableActions";
import { Gender } from "../../../utils/DropDown";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import { toast } from "react-toastify";
import Modal from "../../../components/Modal";
import InputGroup from "../../../components/FormComponent/InputGroup";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
// import Select from "react-select";
import { Icon } from "@iconify/react";
import Layout from "../../../components/Layout";
import { useNavigate, useParams } from "react-router-dom";
import useValidator from "../../../hooks/useValidator";
import { useUserState } from "../../../context/UserContext";
import Select from "react-select";
import PageLoader from "../../../components/PageLoader";
import useWindowSize from "../../../hooks/useWindow";

// const HOSTEL_ENDPOINT = "api/v1";
const EMPLOYEES_ENDPOINT = "api/v1/employees";
// const CLASS_ENDPOINT = "/api/v1/class";
const STUDENT_ENDPOINT = "/api/v1/students";
const HOSTEL_EDIT_ENDPOINT = "/api/v1/hostel-management/hostel/";
const HOSTEL_ROOM = "/api/v1/hostel-management/hostel-rooms/";
const ALL_HOSTEL_ENDPOINT = "/api/v1/hostel-management/all-hostels";
const CREATE_ROOM_ENDPOINT = "/api/v1/hostel-management/hostel/create-room";
const UPDATE_ROOM = "/api/v1/hostel-management/hostel-room/";
const UPDATE_HOSTEL_MASTER = "/api/v1/hostel-management/change-hostel-master/";
const ALLOCATE_ENDPOINT = "/api/v1/hostel-management/hostels/allocate";

const AdminHostel = () => {
  const classes = useStyles();
  const { userRole } = useUserState();
  const { id } = useParams();
  const navigate = useNavigate();
  const [hostels, setHostels] = useState([]);
  // const [classData, setClassData] = useState([]);
  const [itemModal, setItemModal] = useState(false);
  const [allocate, setAllocate] = useState(false);
  const [editRoomModal, setEditRoomModal] = useState(false);
  const [roomModal, setRoomModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRoomCreating, setIsRoomCreating] = useState(false);
  const [deleteRoomModal, setDeleteRoomModal] = useState(false);
  const [isRoomEditing, setIsRoomEditing] = useState(false);
  const [isMasterUpdating, setIsMasterUpdating] = useState(false);
  const [updateMasterModal, setUpdateMasterModal] = useState(false);
  const [isAllocating, setISAllocating] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  // const [classData, setClassData] = useState([]);
  const [studentData, setStudentsData] = useState([]);
  const [allHostels, setAllHostels] = useState([]);
  const [allHostelRoom, setAllHostelRoom] = useState([]);
  const [createRoomValidator, showRoomValidator] = useValidator();
  const [editRoomValidator, showEditRoomValidator] = useValidator();
  const [updateMasterValidator, showUpdateMasterValidator] = useValidator();
  const [allocateHostelValidator, showAllocateHostelValidator] = useValidator();
  const [isRoomGetting, setIsRoomGetting] = useState(false);
  const [currentRow, setCurrentRow] = useState({});
  const width = useWindowSize();
  const mobile = width < 600;
  const [allocations, setAllocations] = useState(
    {
      hostel_id: id,
      // class_id: "",
      students: [],
      room_id: "",
      allocated_by: userRole?.id
    }
  );
  const [hostelRoomForm, setHostelRoomForm] = useState({
    hostel_id: id,
    room_number: "",
    capacity: ""
  });
  const [edithostelRoomForm, setEditHostelRoomForm] = useState({
    hostel_id: id,
    room_number: "",
    capacity: ""
  });

  const [updateHostelMasterForm, setUpdateHostelMasterForm] = useState({
    current_hostel_master_id: "",
    new_hostel_master_id: ""
  });

  const handleOpenAllocateModal = () => {
    setAllocate(!allocate);
  };

  const handleCreateRoomChange = (e) => {
    const { name, value } = e.target;
    setHostelRoomForm({ ...hostelRoomForm, [name]: value });
  };
  const handleUpdateMaster = (e) => {
    const { name, value } = e.target;
    setUpdateHostelMasterForm({ ...updateHostelMasterForm, [name]: value });
  };

  const handleEditRoomChange = (e) => {
    const { name, value } = e.target;
    setEditHostelRoomForm({ ...edithostelRoomForm, [name]: value });
  };

  const handleEditRoomRow = (row) => {
    setCurrentRow(row);
    setEditHostelRoomForm({
      ...edithostelRoomForm,
      room_number: row?.room_number,
      capacity: row?.capacity
    });
    setEditRoomModal(true);
  };

  const handleDeleteRoomRow = (row) => {
    setCurrentRow(row);
    setDeleteRoomModal(true);
  };

  const handleCloseDeleteRoom = () => {
    setCurrentRow({});
    setDeleteRoomModal(false);
  };

  const handleCloseEditModal = () => {
    setCurrentRow({});
    setEditRoomModal(false);
  };

  /**
     * Fetches all classes in the school.
     */
  // const getAllClasses = () => {
  //   httprequest.get(CLASS_ENDPOINT).then((res) => {
  //     setClassData(res?.data?.data);
  //   }).catch((err) => {
  //     toast.error(err?.response?.data);
  //   });
  // };

  const actions = [
    { label: "Create Room", icon: "mdi:door-open" },
    // { label: "Hostel Dues", icon: "tdesign:money" },
    { label: "Inventory", icon: "mdi:clipboard-list-outline" },
    { label: "Messages", icon: "mdi:message-text-outline" },
    ...(userRole?.role === "school_admin"
      ? [{ label: "Hostel Master", icon: "mdi:account-group-outline" }]
      : []),
    { label: "Add Student", icon: "mdi:account-plus-outline" }
  ];

  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
  };
  const handleCreateRoomModal = () => {
    setRoomModal(!roomModal);
  };

  const handleUpdateMasterModal = () => {
    setUpdateMasterModal(!updateMasterModal);
  };

  const handleStudentChange = (selectedOptions) => {
    const studentIds = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
    setAllocations((prev) => ({
      ...prev,
      students: studentIds
    }));
  };
  const recentUser = [
    {
      name: "Room Number",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Room Number</p>}
          {row?.room_number || "--/--"}
        </>
      )
    },
    {
      name: "Room Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Room Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Room Capacity",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Room Capacity</p>}
          {row?.capacity || "--/--"}
        </>
      )
    },
    {
      name: "No of Students",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">No of Students</p>}
          {row?.student_count || "--/--"}
        </>
      )
    },
    {
      name: "Created by",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Created by</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            className="table-action-icon"
            onClick={() => navigate(`/room-detail/${row?.id}`)}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button
            className="table-action-icon"
            onClick={() => handleEditRoomRow(row)}
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          <button
            className="table-action-icon"
            onClick={() => handleDeleteRoomRow(row)}
          >
            <div className="delete-icon"><Icon icon="mingcute:delete-2-line" /></div>
          </button>
        </div>
      )
    }
  ];

  /**
     * Fetches Hostel by ID
     */
  const getAllHostelbyID = () => {
    httprequest.get(`${HOSTEL_EDIT_ENDPOINT}${id}`).then((res) => {
      setHostels(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  /**
     * Fetches all classes in the school.
     */
  const getAllHostelRoom = () => {
    setIsRoomGetting(true);
    httprequest.get(`${HOSTEL_ROOM}${id}`).then((res) => {
      setAllHostelRoom(res?.data?.rooms);
      setSearchResult(res?.data?.rooms);
      setIsRoomGetting(false);
    }).catch((err) => {
      setIsRoomGetting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  /**
     * Fetches all classes in the school.
     */
  const getAllHostels = () => {
    httprequest.get(ALL_HOSTEL_ENDPOINT).then((res) => {
      setAllHostels(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleClick = (label) => {
    if (label === "Create Room") {
      handleCreateRoomModal();
    } else if (label === "Messages") {
      navigate(`/hostel/messages/${id}`);
    } else if (label === "Hostel Master") {
      handleUpdateMasterModal();
    } else if (label === "Add Student") {
      handleOpenAllocateModal();
    } else if (label === "Inventory") {
      navigate(`/hostel/inventory/${id}`);
    }
  };

  /**
     * Fetches the overview data from the server and updates the events and overview state.
     */
  //   const handleGetOverview = () => {
  //     // httprequest.get(HOSTEL_ENDPOINT).then((res) => {
  //     // });
  //     setHostels([]);
  //   };

  /**
   * Fetches all students and separates them into active/inactive categories.
   * Also handles loading state and error toasts.
   */
  const getAllStudents = () => {
    httprequest.get(STUDENT_ENDPOINT).then((res) => {
      setStudentsData(res?.data?.data?.filter((active_stn) => active_stn?.is_active === true)?.map((stdn) => {
        return {
          label: `${stdn?.student?.last_name} ${stdn?.student?.first_name}`,
          value: stdn?.student?.id
        };
      }));
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  /**
   * Fetches employee data from the server based on the selected `value` (e.g., staff status).
   * Updates the employee state and loading state accordingly.
   *
   * @function getEmployeeData
   */
  const getEmployeeData = () => {
    httprequest.get(`${EMPLOYEES_ENDPOINT}`).then((res) => {
      setEmployeesData(res?.data?.data?.employees);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const handleCloseAllocateModal = () => {
    setAllocate(false);
    setAllocations({
      hostel_id: id,
      // class_id: "",
      students: [],
      room_id: "",
      allocated_by: userRole?.id
    });
  };

  const handleAllocateHostel = () => {
    if (allocateHostelValidator.allValid()) {
      setISAllocating(true);
      const payload = {
        allocate_students: [allocations]
      };
      httprequest.post(ALLOCATE_ENDPOINT, payload).then((res) => {
        setISAllocating(false);
        toast.success(res?.data?.message);
        handleCloseAllocateModal();
        getAllHostels();
        getAllHostelbyID();
        getAllHostelRoom();
      }).catch((err) => {
        setISAllocating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showAllocateHostelValidator(true);
    }
  };

  const handleEditRoom = () => {
    if (editRoomValidator.allValid()) {
      setIsRoomEditing(true);
      httprequest.patch(`${UPDATE_ROOM}${currentRow?.id}`, edithostelRoomForm).then((res) => {
        setIsRoomEditing(false);
        toast.success(res?.data?.message);
        getAllHostels();
        getAllHostelbyID();
        getAllHostelRoom();
        handleCloseEditModal();
      }).catch((err) => {
        setIsRoomEditing(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showEditRoomValidator(true);
    }
  };

  const handleUpdateHostelMaster = () => {
    if (updateMasterValidator.allValid()) {
      setIsMasterUpdating(true);
      httprequest.patch(`${UPDATE_HOSTEL_MASTER}${id}`, updateHostelMasterForm).then((res) => {
        setIsMasterUpdating(false);
        toast.success(res?.data?.message);
        getAllHostels();
        getAllHostelbyID();
        getAllHostelRoom();
        handleUpdateMasterModal();
      }).catch((err) => {
        setIsMasterUpdating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showUpdateMasterValidator(true);
    }
  };

  const handleDeleteHostel = () => {
    setIsDeleting(true);
    httprequest.delete(`${UPDATE_ROOM}${currentRow?.id}`).then((res) => {
      setIsDeleting(false);
      toast.success(res?.data?.message);
      getAllHostels();
      getAllHostelbyID();
      getAllHostelRoom();
      setDeleteRoomModal(!deleteRoomModal);
      setCurrentRow({});
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const handleCreateRoom = () => {
    if (createRoomValidator.allValid()) {
      setIsRoomCreating(true);
      httprequest.post(CREATE_ROOM_ENDPOINT, hostelRoomForm).then((res) => {
        setIsRoomCreating(false);
        toast.success(res?.data?.message);
        handleCreateRoomModal();
        getAllHostelbyID();
        getAllHostelRoom();
      }).catch((err) => {
        setIsRoomCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showRoomValidator(true);
    }
  };

  const handleAllocateHostelChange = (e) => {
    const { name, value } = e.target;

    // If hostel_id changes, fetch hostel rooms
    // if (name === "hostel_id" && value) {
    //   getAllHostelRoom(value);
    // }
    // Update the allocations state
    setAllocations((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  useEffect(() => {
    getEmployeeData();
    getAllHostelbyID();
    getAllHostelRoom();
    getAllStudents();
    getAllHostels();
    // getAllClasses();
  }, []);

  useEffect(() => {
    if (hostels?.hostel?.hostel_master?.id) {
      setUpdateHostelMasterForm((prev) => ({
        ...prev,
        current_hostel_master_id: hostels?.hostel?.hostel_master?.id
      }));
    }
  }, [hostels?.hostel?.hostel_master?.id]);

  useEffect(() => {
    if (id) {
      getAllHostelRoom(id);
    }
  }, [id]);

  // --| Filter Inventory table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value?.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = allHostelRoom?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.room_number
                      ?.toLowerCase()
                      .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one="/hostel"
              link_one_name="Hostel Management"
              active={hostels?.hostel?.name}
              description="See details of students in a hostel"
            />
          </div>
          <div>
          </div>
        </div>
        <div className="page-content margin-top-16">
          <div className={classes.flexx}>
            <div className={classes.hosteldetail}>
              <h2>{hostels?.hostel?.name}</h2>
              <p>{hostels?.hostel?.gender} Hostel | {hostels?.hostel?.number_of_bedspace}-Man Room</p>
            </div>
            <div className={classes.container}>
              {actions.map(({ label, icon }) => (
                <div onClick={() => handleClick(label)} key={label} className={classes.item}>
                  <div className={classes.iconWrapper}>
                    <Icon icon={icon} className={classes.iconStyle} />
                  </div>
                  <span className={classes.label}>{label}</span>
                </div>
              ))}
            </div>
          </div>
          {isRoomGetting ? (
            <PageLoader />
          ) : (
            <>
              <Grid container spacing={4}>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CardCount
                    title="Number of Students"
                    count={hostels?.hostel?.number_of_students || 0}
                    icon={<StudentIcon />}
                    leftSubText="Allocated :"
                    rightSubText="UnAllocated :"
                    leftSubValue={hostels?.hostel?.allocated_students || 0}
                    rightSubValue={hostels?.hostel?.unallocated_students || 0}
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CardCount
                    title="Number of Rooms"
                    count={hostels?.hostel?.number_of_rooms || 0}
                    icon={<Icon icon="mdi:guest-room-outline" />}
                    leftSubText="Allocated :"
                    rightSubText="Unallocated :"
                    leftSubValue={hostels?.hostel?.allocated_rooms || 0}
                    rightSubValue={hostels?.hostel?.unallocated_rooms || 0}
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <CardCount
                    title="Number of Bedspace"
                    count={hostels?.hostel?.number_of_bedspace || 0}
                    icon={<ClassIcon />}
                    leftSubText="Allocated :"
                    rightSubText="Unallocated :"
                    leftSubValue={hostels?.hostel?.allocated_bedspace || 0}
                    rightSubValue={hostels?.hostel?.unallocated_bedspace || 0}
                  />
                </Grid>
              </Grid>
              <div className="margin-top-16">
                {allHostelRoom?.length > 0 ? (
                  <Table data={searchResult} columns={recentUser} subHeader={true} pagination subHeaderComponent={
                    <TableSearch placeholder="Search here..." searchTableFunc={handleSearchInventory} />
                  }
                  />
                ) : (
                  <div className={classes.notfound}>
                    <NoData
                      img={NoRecentUsers}
                      title="No Hostel Found"
                      subtitle="No hostel has been created or added"
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        {/* Create Hostels */}
        <Modal
          title="Create Hostels"
          subtitle={
            <div>
                Create a new hostel by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Hostel Name"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="Enter Name"
                    //   onChange={handleChange}
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel Type(Gender)"
                    required
                    children={
                      <select name="session_id">
                        <option value="">--- Select ---</option>
                        {Gender?.map((gender) => {
                          return (
                            <option key={gender.key} value={gender?.key}>
                              {gender?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel Master"
                    required
                    children={
                      <select name="hostel_master">
                        <option value="">--- Select ---</option>
                        {employeesData?.map((employee) => {
                          return (
                            <option key={employee?.employee_id} value={employee?.employee_id}>
                              {`${employee?.first_name} ${employee?.last_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Number of Rooms"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="Enter rooms"
                    //   onChange={handleChange}
                  />
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Room Capacity"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="Enter rooms"
                    //   onChange={handleChange}
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Create Hostel"
                // onClick={handleCreateScore}
                // isLoading={scoreCreateLoading}
                />
              </div>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
        {/* Create Rooms */}
        <Modal
          title="Create Room"
          subtitle={
            <div>
                Create Room by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel"
                    required
                    children={
                      <select disabled defaultValue={id}>
                        <option value="">--- Select ---</option>
                        {allHostels?.map((hostels) => {
                          return (
                            <option key={hostels?.id} value={hostels?.id}>
                              {hostels?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {createRoomValidator.message("Hostel Name", hostelRoomForm?.hostel_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Room Number"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="room_number"
                    onChange={handleCreateRoomChange}
                  />
                  {createRoomValidator.message("Room Number", hostelRoomForm?.room_number, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Room Capacity"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="capacity"
                    onChange={handleCreateRoomChange}
                  />
                  {createRoomValidator.message("Room Capacity", hostelRoomForm?.capacity, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Create Room"
                  onClick={handleCreateRoom}
                  isLoading={isRoomCreating}
                />
              </div>
            </>
          }
          isopen={roomModal}
          closeModal={handleCreateRoomModal}
        />

        {/* Edit Room Modal */}
        <Modal
          title={`Edit ${currentRow?.name}`}
          subtitle={`Edit details of ${currentRow?.name} in your Hostel `}
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel"
                    required
                    children={
                      <select disabled defaultValue={id}>
                        <option value="">--- Select ---</option>
                        {allHostels?.map((hostels) => {
                          return (
                            <option key={hostels?.id} value={hostels?.id}>
                              {hostels?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {editRoomValidator.message("Hostel Name", edithostelRoomForm?.hostel_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Room Number"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="room_number"
                    defaultValue={edithostelRoomForm?.room_number}
                    onChange={handleEditRoomChange}
                  />
                  {editRoomValidator.message("Room Number", edithostelRoomForm?.room_number, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Room Capacity"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="capacity"
                    onChange={handleEditRoomChange}
                    defaultValue={edithostelRoomForm?.capacity}
                  />
                  {editRoomValidator.message("Room Capacity", edithostelRoomForm?.capacity, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button
                type="submit"
                onClick={handleEditRoom}
                variant="primary"
                buttonName="Edit Room"
                buttonSize="full"
                color="btndefault"
                isLoading={isRoomEditing}
              />
            </>
          }
          isopen={editRoomModal}
          closeModal={handleCloseEditModal}
        />
        {/* Delete Modal */}
        <Modal
          title="Delete Room"
          subtitle={`Are you sure you want to delete  ${currentRow?.name} hostel.`}
          modalContent={
            <>
              <div>
              </div>
            </>
          }
          modalFooter={
            <>
              <Button
                type="submit"
                variant="danger"
                buttonName="Delete Room"
                buttonSize="full"
                color="btndefault"
                onClick={handleDeleteHostel}
                isLoading={isDeleting}
              />
            </>
          }
          isopen={deleteRoomModal}
          closeModal={handleCloseDeleteRoom}
        />
        {/* Update Hostel Master */}
        <Modal
          title="Update Hostel Master"
          subtitle={
            <div>
                Update hostel master by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Current Hostel Master"
                    required
                    children={
                      <select disabled defaultValue={hostels?.hostel?.hostel_master?.id} onChange={handleUpdateMaster} name="hostel_master_id">
                        <option value="">--- Select ---</option>
                        {employeesData?.map((employee) => {
                          return (
                            <option key={employee?.user_id} value={employee?.user_id}>
                              {`${employee?.first_name} ${employee?.last_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {updateMasterValidator.message("Current Hostel Master", updateHostelMasterForm?.current_hostel_master_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="New Hostel Master"
                    required
                    children={
                      <select onChange={handleUpdateMaster} name="new_hostel_master_id">
                        <option value="">--- Select ---</option>
                        {employeesData?.map((employee) => {
                          return (
                            <option key={employee?.user_id} value={employee?.user_id}>
                              {`${employee?.first_name} ${employee?.last_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {updateMasterValidator.message("New Hostel Master", updateHostelMasterForm?.new_hostel_master_id, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Update Hostel Master"
                  onClick={handleUpdateHostelMaster}
                  isLoading={isMasterUpdating}
                />
              </div>
            </>
          }
          isopen={updateMasterModal}
          closeModal={handleUpdateMasterModal}
        />
        {/* Allocate Hostels */}
        <Modal
          title="Alocate Hostels"
          subtitle={
            <div>
                        Allocate a hostel to a student by filling in the details below.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Hostel"
                    required
                    children={
                      <select disabled defaultValue={id} onChange={handleAllocateHostelChange} name="hostel_id">
                        <option value="">--- Select ---</option>
                        {allHostels?.map((hostel) => {
                          return (
                            <option key={hostel?.id} value={hostel?.id}>
                              {hostel?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {allocateHostelValidator.message("Hostel", allocations?.hostel_id, "required")}
                </Grid>
                {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Class"
                    required
                    children={
                      <select onChange={handleAllocateHostelChange} name="class_id">
                        <option value="">--- Select ---</option>
                        {classData?.map((classes) => {
                          return (
                            <option key={classes?.id} value={classes?.id}>
                              {classes?.class_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {allocateHostelValidator.message("Class", allocations?.class_id, "required")}
                </Grid> */}
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <div className="multiple-select">
                    <p>Students</p>
                    <Select
                      name="students"
                      options={studentData}
                      placeholder="Select a student"
                      isMulti
                      isClearable
                      onChange={handleStudentChange}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </div>
                  {allocateHostelValidator.message("Students", allocations?.students, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Room Number"
                    required
                    children={
                      <select onChange={handleAllocateHostelChange} name="room_id">
                        <option value="">--- Select ---</option>
                        {allHostelRoom?.map((room) => {
                          return (
                            <option key={room.id} value={room?.id}>
                              {room?.name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {allocateHostelValidator.message("Hostel Room", allocations?.room_id, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Allocate Hostel"
                  onClick={handleAllocateHostel}
                  isLoading={isAllocating}
                />
              </div>
            </>
          }
          isopen={allocate}
          closeModal={handleCloseAllocateModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default AdminHostel;
